import React from 'react';
import { useTenant } from '../contexts/TenantContext';
import CustomerPanelLoading from './CustomerPanelLoading';
import FeatureUnavailable from './FeatureUnavailable';

const RequireFeature = ({ feature, children }) => {
  const { entitlements, isTenantSessionLoading } = useTenant();
  if (isTenantSessionLoading || entitlements === null) return <CustomerPanelLoading />;
  if (entitlements && entitlements[feature]) return children;
  return <FeatureUnavailable />;
};

export default RequireFeature;
